import { useNavigate } from 'react-router-dom';
import { Button } from 'components/ui';
import { SearchIcon, PlusIcon } from 'components/icons';
import { ROUTES } from 'lib/constants';

/** Search box + item count + "Add product" action above the catalog grid. */
export function CatalogToolbar({ search, onSearchChange, count }) {
  const navigate = useNavigate();

  return (
    <div className="mb-5 flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
      <div className="relative w-full sm:max-w-xs">
        <SearchIcon className="pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-slate-400" />
        <input
          type="search"
          value={search}
          onChange={(event) => onSearchChange(event.target.value)}
          placeholder="Search products"
          aria-label="Search products"
          className="h-10 w-full rounded-lg border border-surface-300 bg-white pl-9 pr-3 text-sm text-slate-900 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-brand-500/40"
        />
      </div>

      <div className="flex items-center justify-between gap-3 sm:justify-end">
        {typeof count === 'number' && (
          <span className="text-sm text-slate-500">
            {count} item{count === 1 ? '' : 's'}
          </span>
        )}
        <Button leftIcon={<PlusIcon className="h-4 w-4" />} onClick={() => navigate(ROUTES.CATALOG_ADD)}>
          Add product
        </Button>
      </div>
    </div>
  );
}

export default CatalogToolbar;
